import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { type OptionDto } from "../../../autogen/bff-api";
import { useExtensionName } from "./extensionName";
import { isDecided } from "./extensionStatus";
import { useOptionStatusText } from "./OptionPeriod";

export const useAlreadyDecidedMessage = (options: OptionDto[]) => {
  const { t } = useTranslation();
  const nameOf = useExtensionName(options);
  const statusText = useOptionStatusText();
  return useCallback(
    (option: OptionDto): string =>
      isDecided(option)
        ? String(t("{{name}} is already decided: {{status}}", { name: nameOf(option), status: statusText(option) }))
        : String(t("{{name}} is already decided. Reload the page to see the decision.", { name: nameOf(option) })),
    [t, nameOf, statusText]
  );
};
